import axios from 'axios';

class AccessiService {
  state = {
    server: '',
    BaseUrl: '/accessi',
  };
  resolveServer = () => {
    if (this.state.server) {
      return this.state.server;
    }

    const envBaseUrl = process.env?.REACT_APP_API_BASE_URL?.trim();
    if (envBaseUrl) {
      this.state.server = envBaseUrl.replace(/\/$/, '');
      return this.state.server;
    }

    this.state.server = '';
    return this.state.server;
  };
  getUrl = () => {
    return this.resolveServer();
  };
  getAccessiUrl = () => {
    return `${this.getUrl()}${this.state.BaseUrl}`;
  };
  getAllAccessiData = () => {
    const url = `${this.getAccessiUrl()}/cerca/all`;
    console.log('getAllAccessiData', url);
    return axios.get(url);
  };
  getAccessiCodice = (codice) => {
    const url = `${this.getAccessiUrl()}/cerca/codice/${codice}`;
    console.log('getAccessiCodice', url);
    return axios.get(url);
  };
  deleteAccessiByCode = (codice) => {
    return axios.get(`${this.getAccessiUrl()}/elimina/codice/${codice}`);
  };
}

export default new AccessiService();
